module.exports = __webpack_public_path__ + "img/Icon_Registro_de_Visitas.e7a5d9fb.svg";